import { render } from "./PeoplePieChartSmall.vue?vue&type=template&id=2dca972b&scoped=true"
import script from "./PeoplePieChartSmall.vue?vue&type=script&lang=js"
export * from "./PeoplePieChartSmall.vue?vue&type=script&lang=js"

import "./PeoplePieChartSmall.vue?vue&type=style&index=0&id=2dca972b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dca972b"]])

export default __exports__